import {Component, inject, Input} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {CertificateSyncButtonComponent} from '../../../../shared/commons/certificate-sync-button/certificate-sync-button.component';
import {CertificateAddButtonComponent} from '../../../../shared/commons/certificate-add-button/certificate-add-button.component';
import {FileUploadComponent} from '../file-upload/file-upload.component';
import {CertificateSelectComponent} from '../../../../shared/commons/certificate-select/certificate-select.component';
import {
  SubdistrictAutocompleteComponent
} from '../../../../shared/commons/subdistrict-autocomplete/subdistrict-autocomplete.component';
import {FormRegistrationDirective} from '../../../../shared/commons/form-registration.directive';
import {BUSINESS_FORM} from '../business-form.token';
import {AddBusinessFormData} from '../add-business-form-data';

@Component({
  selector: 'app-individual-form',
  imports: [
    FormsModule,
    FileUploadComponent,
    CertificateSelectComponent,
    CertificateSyncButtonComponent, CertificateAddButtonComponent,
    SubdistrictAutocompleteComponent,
    FormRegistrationDirective
  ],
  templateUrl: './individual-form.component.html',
  styleUrl: './individual-form.component.scss'
})
export class IndividualFormComponent {
  protected formData: AddBusinessFormData = inject(BUSINESS_FORM);

  @Input() form?: NgForm;
}
